function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export { addDays };
//# sourceMappingURL=helpers.js.map
